export enum FlightModeEnum {
    HOLD = 'HOLD',
    OFFBOARD = 'OFFBOARD',
}

export interface FlightEntity {
    serialNumber?: string;
    estimatedFlightTime?: number;
    speed?: number;
    distance?: number;
    altitude?: number;
    latitude?: number;
    longitude?: number;
    timestamp?: number;
    batteryHealth?: number;
    currentMissionId?: string;
    totalDistance?: number;
    flightMode?: string;
    heading?: number;
    missionProgress?: number;
}